import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormArray } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { PublicService } from 'src/app/business-service/public/public.service';
import { VisaService } from 'src/app/business-service/visa/visa.service';
import { GlobalService } from 'src/app/modules/shared/services/global/global.service';
import { LovDataService } from 'src/app/modules/shared/services/lov-data/lov-data.service';
import { ModalsService } from 'src/app/modules/shared/services/modals/modals.service';
import { ResponseNotificationService } from 'src/app/modules/shared/services/response-notification/response-notification.service';

@Component({
  selector: 'app-visa-documents-collection-form',
  templateUrl: './visa-documents-collection-form.component.html',
  styleUrls: ['./visa-documents-collection-form.component.scss'],
})
export class VisaDocumentsCollectionFormComponent implements OnInit {

  @Input() visaId: any;
  @Input() leadId: any;
  @Input() storedFormData: any;
  @Input() editVisaId: any;

  @Input() visaLeadDetails: any;
  @Input() visaImportantInfo: any;

  code: any = "";
  showSpinner: boolean = false;

  visaForm!: FormGroup;

  noOfPassengers: number = 0;

  documentsBasedOnImportantInformation: any[] = [];

  constructor(
    private _globalService: GlobalService,
    private _fb: FormBuilder,
    private _modalService: ModalsService,
    private _responseNotificationService: ResponseNotificationService,
    private _lovDataSerivce: LovDataService,
    private _activatedRoute: ActivatedRoute,
    private _publicService: PublicService
  ) { }

  async ngOnInit() {
    this.code = this._activatedRoute.snapshot.paramMap.get("code");

    // TODO: update hardcored values
    var res = await this.loadVisaDetails(this.code)
    // Storing data of important information if tab is filled
    if (this.visaImportantInfo) {
      this.updateVisaImportantDocumentsData();
    }

    this.visaForm = this._fb.group({
      data: this._fb.array([])
    });

    // Creating form groups for passengers entered in visa lead tab
    this.createVisaGroupsForPassengers();

    if (this.storedFormData) {
      this.patchVisaForm(this.storedFormData.data);
    }
  }

  get today(): Date {
    let date = new Date();
    date.setHours(0, 0, 0, 0);
    return date;
  }

  async loadVisaDetails(code:any):Promise<any>{
    this.showSpinner = true;
    return new Promise((resolve, reject)=>{
      this._publicService.getVisaByCode(code).subscribe({
        next: (res:any)=>{
          this.showSpinner = false;
          this.storedFormData = res.visaDocuments;
          this.visaLeadDetails = res.visaLeadInfo;
          this.visaImportantInfo = res.importantInformation;
          resolve(res);
        },
        error: (err:any)=>{
          this.showSpinner = false;
          console.log(err);
          reject(err);
        }
      })
    })
  }

  convertToDate(value: any): Date {
    return new Date(value)
  }

  updateVisaImportantDocumentsData() {
    let mandatoryDocuments = this.visaImportantInfo.mandatoryDocuments?.data;
    let documentsBasedOnType = this.visaImportantInfo.documentsBasedOnVisa?.data;
    let otherDocuments = this.visaImportantInfo.otherDocuments?.data;

    if (mandatoryDocuments) {
      mandatoryDocuments.forEach((item: any) => {
        if (item.isDocumentRequired) {
          this.documentsBasedOnImportantInformation.push(item)
        }
      });
    }
    if (documentsBasedOnType) {
      documentsBasedOnType.forEach((item: any) => {
        if (item.isDocumentRequired) {
          this.documentsBasedOnImportantInformation.push(item)
        }
      });
    }
    if (otherDocuments) {
      otherDocuments.forEach((item: any) => {
        if (item.isDocumentRequired) {
          this.documentsBasedOnImportantInformation.push(item)
        }
      });
    }

  }

  // Patching stored data

  patchVisaForm(formData: any) {
    const visaDocumentCollection = this.visaForm.get('data') as FormArray;
    visaDocumentCollection.controls.forEach((element: any, index: number) => {
      let contactId = element.get('contactId')?.value;
      let storedVisaPassenger = formData?.find((item: { contactId: any; }) => item.contactId == contactId);

      if (storedVisaPassenger) {
        const { documents, ...storedVisaPassengerWithoutDocuments } = storedVisaPassenger;
        visaDocumentCollection.at(index).patchValue(storedVisaPassengerWithoutDocuments);
        this.patchPassengerDocuments(documents, index);
      }
    });
  }

  patchPassengerDocuments(documents: any[], visaIndex: number) {
    const documentArray = this.documentsArray(visaIndex) as FormArray;

    // patch here based on document name mapping
    documentArray.controls.forEach((element: any, docIndex: number) => {
      let docName = element.get('documentName')?.value;
      let storedDoc = documents?.find((doc: any) => doc.documentName == docName);
      if (storedDoc) {
        documentArray.at(docIndex)?.patchValue({
          documentName: storedDoc.documentName,
          documentNumber: storedDoc.documentNumber,
          validFrom: storedDoc.validFrom ? this.convertToDate(storedDoc.validFrom) : null,
          validTo: storedDoc.validTo ? this.convertToDate(storedDoc.validTo) : null,
          imagePath: storedDoc.imagePath,
          document: storedDoc.imagePath,
          docName: storedDoc.fileName
        })
      }
    })
  }



  createVisaGroupsForPassengers() {
    let passengerInfo = this.visaLeadDetails.passengerInfo;
    const visaDocumentCollection = this.visaForm.get('data') as FormArray;
    visaDocumentCollection.clear();

    for (let i = 0; i < passengerInfo?.length; i++) {
      const passengerFormGroup = this.createPassengerVisaGroup(passengerInfo[i], null);
      visaDocumentCollection.push(passengerFormGroup);
    }
  }

  visasArray(): FormArray {
    return this.visaForm.get('data') as FormArray;
  }
  createPassengerVisaGroup(passenger: any, storedVisaPassenger: any): FormGroup {
    const passengerFormGroup = this._fb.group({
      leadId: [this.leadId],
      visaId: [this.visaId],
      firstName: [passenger.firstName],
      lastName: [passenger.lastName],
      dateOfBirth: [this.convertToDate(passenger.dateOfBirth)], // DOB field
      age: [this._globalService.calculateAge(passenger.dateOfBirth)], // Age field, calculated automatically
      gender: [passenger.gender],
      nationality: [passenger.nationality],
      visaType: [passenger.visaType],
      applicantType: [passenger.applicantType],
      contactId: [passenger.contactId],
      status: [storedVisaPassenger?.status || null],
      issueDate: [storedVisaPassenger?.issueDate || null],
      expiryDate: [storedVisaPassenger?.expiryDate || null],
      documents: this._fb.array(this.generateDefaultDocumentsArray(passenger)), // Dynamic array of documents
      // Properties of base entity
      id: [storedVisaPassenger?.id || null],
      organizationId: [storedVisaPassenger?.organizationId || null],
      ownership: [storedVisaPassenger?.ownership || ''],
      ownershipRole: [storedVisaPassenger?.ownershipRole || ""],
      createDate: [storedVisaPassenger?.createDate || ''],
      createdBy: [storedVisaPassenger?.createdBy || '']
    });

    // Add a subscription to calculate age based on DOB
    passengerFormGroup.get('dateOfBirth')?.valueChanges.subscribe((dob: any) => {
      if (dob) {
        const calculatedAge = this._globalService.calculateAge(this._globalService.formatDateTimeToDate(dob));
        passengerFormGroup.get('age')?.setValue(calculatedAge);
      }
    });

    return passengerFormGroup;
  }

  generateDefaultDocumentsArray(passenger: any): any[] {
    let array: any[] = [];
    this.documentsBasedOnImportantInformation?.forEach(element => {
      if (!element?.visaTypes && !element?.applicantTypes) {
        array.push(this.createDocumentGroup(element));
      } else {
        if (element.visaTypes?.includes(passenger.visaType) && element.applicantTypes?.includes(passenger.applicantType)) {
          array.push(this.createDocumentGroup(element));
        }
      }
    });
    return array;
  }

  documentsArray(index: number): FormArray {
    return this.visasArray().at(index).get("documents") as FormArray;
  }
  createDocumentGroup(document: any): FormGroup {
    return this._fb.group({
      documentName: [document?.name],
      documentNumber: [''],
      validFrom: [''],
      validTo: [''],
      document: [null],
      imagePath: [null],
      docName: [''],
    });
  }

  // attachments functions

  onDocumentSelected(event: any, visaIndex: number, docIndex: number) {
    const file = event.target.files[0];
    // Checking if image is more than 10MB
    if (file.size > 10 * 1024 * 1024) {
      this._globalService.customAlert("File size should be less than 10MB", "Invalid File Size");
      return;
    }
    let visaGroup = this.visasArray().at(visaIndex).get("documents") as FormArray;
    if (file) {
      let data = new FormData();
      data.append('image', file);
      try {
        this._publicService.uploadVisaImage(data, this.code).subscribe((res) => {
          visaGroup.at(docIndex).get("document")?.setValue(file);
          visaGroup.at(docIndex).get("imagePath")?.setValue(res);
          this.visaForm.markAsTouched();
        })
      } catch (error) {
        console.error("Error while uploading doc", error);
        this._responseNotificationService.showMessage("Failed to upload document, please try again.", true);
      }

      visaGroup.at(docIndex).get("document")?.setValue(file);
      this.visaForm.markAsDirty();
    }
  }

  openAttachment(file: any) {
    if (file instanceof File) {
      const fileURL = URL.createObjectURL(file);
      this._modalService.openImageModal(fileURL)
    } else {
      this._modalService.openImageModal(file)
    }
  }

  async onSubmit(): Promise<boolean> {
    try {
      const formData = this.serializeFormData(this.visaForm.value);
      console.log(formData);
      this.showSpinner = false;
      const data = await this._publicService.addVisaDocuments(this.code, formData).toPromise();
      this.showSpinner = false;
      this.visaForm.markAsPristine();
      this._responseNotificationService.showMessage("Visa Document Collection Added Successfully");
      return true;

    } catch (error) {
      console.error("Error while adding Visa Document Collection", error);
      this._responseNotificationService.showMessage("Failed to add Visa Document Collection", true);
      return false;
    }
  }

  serializeFormData(data: any): any {
    const serializeData = data;
    serializeData.data = serializeData.data.map((item: any) => ({
      ...item,
      issueDate: this._globalService.convertDateToString(item.issueDate),
      expiryDate: this._globalService.convertDateToString(item.expiryDate),
      documents: item.documents.map((doc: any) => ({
        ...doc,
        validFrom: this._globalService.convertDateToString(doc.validFrom),
        validTo: this._globalService.convertDateToString(doc.validTo),
      }))
    }))
    return serializeData;
  }

  formDataModified(): boolean {
    return (this.visaForm.dirty || this.visaForm.invalid) && this.visaForm.touched;
  }

  getVisaStatus(status: any): any {
    if (!Array.isArray(status) || status.length === 0) {
      return null;
    }
    for (let i = status.length - 1; i >= 0; i--) {
      const item = status[i];
      if (item?.checked) {
        return item;
      }
    }
    return null;
  }

}
